import React, { useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { IoSave } from 'react-icons/io5'
import { Link, useParams } from 'react-router-dom'
import { FcNook } from 'react-icons/fc'
import {
    AlertType, classDivBackground, classInput, classInputDark, classLabel, classLabelDark, classBt, classDivBody,
    classbtAzul, classBorderLabelDark, classWeigthBt, bgBlue, bgRed, barraVermelhoAzul, focusRed, focusLabelRed, classbtColunasVermelho,
    classbtCinzaClaro, classUserCriarAtt, classDtCriarAtt
} from '../../Utils/Types'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { MarcaService } from './MarcaService'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import moment from 'moment'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const MarcaNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'descricao', erro: false }, // Posição 0 do Array.    
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idmarca } = useParams<string>()
    const [id, setId] = useState(0)
    const [descricao, setDescricao] = useState("")
    const [descricaoCopia, setDescricaoCopia] = useState("")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||    
    const getAttributes = async () => {

        setVisible(false)
        setLoading(true)

        try {

            if (idmarca) {

                const marcaAttributes = await MarcaService.GetAttributes(idmarca)

                if (marcaAttributes.data) {

                    setId(marcaAttributes.data.id)
                    setDescricao(marcaAttributes.data.description)
                    setDescricaoCopia(marcaAttributes.data.description)

                    setUserCriador(marcaAttributes.data.name_user_insert || '')
                    setUsertAtt(marcaAttributes.data.name_user_last_update || '')

                    if (marcaAttributes.data.dt_cadastro) {
                        const dataFormatadaCriacao = moment(marcaAttributes.data.dt_cadastro).format('DD/MM/YYYY HH:mm')
                        setDtCriador(dataFormatadaCriacao)
                    }

                    if (marcaAttributes.data.dt_last_update) {
                        const dataFormatadaAtt = moment(marcaAttributes.data.dt_last_update).format('DD/MM/YYYY HH:mm')
                        setDtAtt(dataFormatadaAtt)
                    }
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const descricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MARCAS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novaMarca = () => {
        setId(0)
        setDescricao("")

        setDtCriador('')
        setDtAtt('')
        setUserCriador('')
        setUsertAtt('')

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        //redefinirCampos()
        inputFocus()
    }

    const handleSaveMarca = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)

        try {

            let marca: any = {
                description: descricao
            }

            if (id > 0) {
                marca.id = id
            }

            const resp = await MarcaService.Save(marca)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios()

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados da marca atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setDescricaoCopia(resp.data.marca.descricao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                //redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar a marca. Por favor, tente novamente` : `Não foi possível salvar a marca. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const checkDadosObrigatorios = (): boolean => {

        if (descricao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'descricao' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'descricao', erro: false }, // Posição 0 do Array.    
        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("descricao")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- TAB ------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    const btNovoVisible = parseInt(idmarca || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idmarca || '') || id > 0 ? `Editar - Marca - ${descricaoCopia}` : `Cadastro - Marca`}</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Dados da Marca</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>

                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8`}>

                                        <div className={`${barraVermelhoAzul} ${descricao != '' ? bgBlue : bgRed}`} />
                                        <input id="descricao" className={`${classInput} ${classInputDark} ${descricao != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={100} placeholder=" " autoComplete='off' value={descricao} onChange={descricaoChange} />
                                        <label htmlFor="descricao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${descricao != '' ? '' : focusLabelRed}`}>Descrição</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/marca" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novaMarca} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveMarca} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} >
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idmarca || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}

                                    </button>

                                </div>
                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoMarca" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoMarca" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoMarca" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoMarca" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttMarca" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttMarca" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttMarca" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttMarca" className={`${classDtCriarAtt}`} >{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_marca.mp4'
                            title='Como cadastrar uma marca'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}